//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = '/prototype/accounting/general-ledger/budgets';

export default {

    computed: {
        filteredData: function filteredData() {

            var filterKey = this.filterKey && this.filterKey.toLowerCase();
            var data = this.items;
            if (filterKey) {
                data = data.filter(function (row) {
                    return Object.keys(row).some(function (key) {
                        return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
                    });
                });
            }

            return data;
        }
    },

    mounted: function mounted() {
        var _this = this;

        Event.$on('refresh-gl-budgets', function () {
            return _this.refresh();
        });

        Event.$on('remove-budget', function (item) {
            axios.post(BASE_URL + '/destroy', { id: item }).then(function () {
                _this.refresh();
            });
        });
    },


    methods: {
        add: function add() {
            Event.$emit('add-new-budget');
        },
        edit: function edit(item) {
            Event.$emit('edit-budget', item);
        },
        refresh: function refresh() {
            var _this2 = this;

            Object.assign(this.$data, this.$options.data());
            axios.post(BASE_URL).then(function (response) {
                var monthTotals = [];
                response.data.map(function (budget) {
                    budget.items.map(function (item) {
                        Object.keys(item).forEach(function (month) {
                            if (!['account', 'gl_account_id', 'gl_budget_id', 'created_at', 'updated_at', 'deleted_at', 'id'].includes(month)) {
                                if (isNaN(monthTotals[month])) {
                                    monthTotals[month] = 0;
                                }
                                monthTotals[month] += item[month];
                            }
                        });
                    });
                    _this2.items.push({
                        id: budget.id,
                        name: budget.name,
                        "data": [{
                            name: "Budget",
                            data: [["Jan", monthTotals['jan']], ["Feb", monthTotals['feb']], ["Mar", monthTotals['mar']], ["Apr", monthTotals['apr']], ["May", monthTotals['may']], ["Jun", monthTotals['jun']], ["Jul", monthTotals['jul']], ["Aug", monthTotals['aug']], ["Sep", monthTotals['sep']], ["Oct", monthTotals['oct']], ["Nov", monthTotals['nov']], ["Dec", monthTotals['dec']]]
                        }]
                    });
                });
            });
        },
        remove: function remove(id) {
            Event.$emit('confirm-delete', id, '', 'remove-budget', 'Do you want to delete this budget?');
        }
    },

    data: function data() {
        return {
            filterKey: '',
            items: [

                /* sample structure below
                {
                    "name":"Test Budget #1",
                    "data": [
                            {
                                name: "Budget",
                                data: [["Jan", 100], ["Feb", 200], ["Mar", 150],["Apr", 100], ["May", 200], ["Jun", 150],["Jul", 100], ["Aug", 200], ["Sep", 150],["Oct", 100], ["Nov", 200], ["Dec", 150]]
                            },
                            {
                                name: "Actual",
                                data: [["Jan", 120], ["Feb", 100], ["Mar", 100],["Apr", 150], ["May", 120], ["Jun", 100],["Jul", 80], ["Aug", 20], ["Sep", 100],["Oct", 10], ["Nov", 100], ["Dec", 50]]
                            }
                    ]
                 }
                */
            ]
        };
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/budget/BudgetList.vue
// module id = bFwC
// module chunks = 0 1